<template>
  <div class="level">
    <div class="level-item">
      <div class="block has-text-centered flex-c">

        <!-- logo -->
        <img id="logo" class="image" src="@/assets/images/fend-logo.png">

        <!-- subtitle -->
        <div class="my-5">Forgot your password?</div>

        <form v-on:submit.prevent="submit" novalidate class="forgot-form">
          <!-- email -->
          <div class="field">
            <div class="control">
              <input class="input" :class="{'is-danger': errors.email}"
                     type="email" placeholder="Email" v-model="email">
            </div>
          </div>

          <!-- submit -->
          <div class="control">
            <button class="button is-fullwidth is-primary">Reset password</button>
          </div>
        </form>

        <!-- login -->
        <div class="pt-4 is-size-6">
          <router-link class="has-text-primary" to="/login">Back to Login</router-link>
        </div>

        <!-- success message -->
        <div v-show="message" class="pt-6 is-size-6 has-text-grey-dark">
          {{message}}
        </div>
        </div>
    </div>
  </div>
</template>

<script>
import api from '@/api';

export default {
  name: 'forgot',
  data() {
    return {
      email: '',
      message: '',
      errors: {}
    };
  },
  methods: {
    async submit() {
      try {
        await api.auth.forgot(this.email);
        this.message = 'If your email exists in our system, a password reset email will be sent.';
        this.errors = {};
      } catch (error) {
        this.errors = error.data || {};
      }
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  #logo {
    max-width: 175px;
  }
  .level {
    flex-grow: 1;
    min-width:0; min-height:0;
  }
  .block {
    max-width: 400px;
  }
  .forgot-form {
    max-width: 300px;
  }
</style>
